module.exports = __webpack_public_path__ + "img/up-arrow.9ef19e0b.svg";